import { getAllCampaigns, getAllCreditNotes, getAllCustomers, getAllInvoices, getAllReturnOrders, getAllSalesOrders, getBillableOrders, getCampaignById, getCampaignReferenceData, getCustomerById, getCustomerReferenceData, getCustomersBySearch, getInvoiceById, getPrintInvoiceById, getReturnOrderById, getSalesOrderRowsById, getSalesOrdersById, getSalesOrdersBySearch } from "src/utils/apiRequests";
import useResponse, { useResponseLegacy } from "../useResponse";
import useGetAllPaginatedItemsLegacy, { useGetAllPaginatedItems } from "../useGetAllPaginatedItems";

export const useGetAllOrders = (shouldRequest: boolean | { current: boolean } = true) => {
    return useGetAllPaginatedItemsLegacy<any>(getAllSalesOrders, 500, "SalesOrderId", null, shouldRequest);
}
export const useGetSalesOrdersBySearch = (searchValue) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getSalesOrdersBySearch,values:{searchValue}, requestNothingOnNull:true, dependency:searchValue, extraCacheKey:String(searchValue)});
    console.log("useGetSalesOrdersBySearch", result);
    return result;
}



export const useLatestOrders = (amount = 5) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getAllSalesOrders,values:{amount,pageSize:1}, requestNothingOnNull:true});
    return result;
}


export const useGetAllReturns = (shouldRequest = true) => {
    return useGetAllPaginatedItemsLegacy<any>(getAllReturnOrders, 500, "ReturnOrderId",null,shouldRequest);
    
}
export const useLatestReturns = (amount = 5) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getAllReturnOrders,values:{amount,pageSize:1}, requestNothingOnNull:true});
    return result;
}


export const useOrderRowsById = (id:string) => {
    const [response] = useResponseLegacy<any[]>(getSalesOrderRowsById,{id}, true);
    return response;
}

export const useOrdersById = (id:string) => {
    const [response] = useResponseLegacy<any[]>(getSalesOrdersById,{id}, true,id);
    console.log("useOrdersById", response);
    return response;
}
export const useReturnsById = (id:string, dependecy?) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getReturnOrderById,values:{id}, requestNothingOnNull:true, dependency:dependecy});
    return result;
}

export const useGetAllCreditNotes = () => {
    return useGetAllPaginatedItemsLegacy<any>(getAllCreditNotes, 1000, "CreditNoteId");
    
}
export const useGetAllInvoices = () => {
    return useGetAllPaginatedItems<any>({requestFunction:getAllInvoices, pageSize:1000, idField:"Id"});
    
}

export const useInvoiceById = (id:string) => {
    const response = useResponse<any[]>({requestFunction:getInvoiceById,values:{id}, requestNothingOnNull:true, dependency:id});
    return response?.rows ? response?.rows[0] : null;
}
export const useGetAllCampaigns = () => {
    return useGetAllPaginatedItemsLegacy<any>(getAllCampaigns, 1000, "Id");
    
}
export const useCampaignId = (id:string) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getCampaignById,values:{id}, requestNothingOnNull:true, dependency:id});
    return result;
}
export const useCampaignReferenceData = () => {
    const {rows} = useResponse<any[]>({requestFunction:getCampaignReferenceData});
    return rows;
}



export const useGetAllCustomers = () => {
    const { rows, status } = useGetAllPaginatedItems<any>({requestFunction:getAllCustomers, pageSize:1000, idField:"AccountId"});
    return { rows, status };
    
}
export const useGetCustomersBySearch = (searchValue) => {
    //const {rows: result} = useGetAllPaginatedItems<any[]>({requestFunction:getCustomersBySearch,idField:"AccountId",requestValues:{searchValue}, shouldRequest: searchValue != null});
    const {rows: result} = useResponse<any[]>({requestFunction:getCustomersBySearch,values:{searchValue}, requestNothingOnNull:true, dependency:searchValue, extraCacheKey:String(searchValue)});
    //console.log("useGetCustomersBySearch", result, searchValue);
    return result;
}




export const useCustomerById = (id:string) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getCustomerById,values:{id}, requestNothingOnNull:true, dependency:id});
    return result;
}
export const useCustomerReferenceData = () => {
    return useResponse<any>({requestFunction:getCustomerReferenceData});
}



export const usePrintInvoiceById = (id:string, dependecy) => {
    const response = useResponse<any[]>({requestFunction:getPrintInvoiceById,values:{id}, requestNothingOnNull:true, dependency:dependecy});
 //   console.log("usePrintInvoiceById", response);
    return response?.rows ? response?.rows : null;
}

export const useBillableOrders = () => {
    const [response] = useResponseLegacy<any[]>(getBillableOrders);
    return response;
}
